var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconComputerShield927Dg34E8C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.129,
    y: 236.321,
    fill: "#9AD7D2",
    width: 96.793,
    height: 14.244
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.527,
    y: 217.795,
    fill: "#E5E5E4",
    width: 20.001,
    height: 18.527
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9AD7D2",
    d: "M29.139,207.663c0,5.725,3.01,10.132,8.699,10.132h224.324c5.668,0,8.699-4.534,8.699-10.132v-13.272 H29.139V207.663z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E4",
    d: "M262.162,49.435H37.838c-5.438,0-8.699,3.639-8.699,10.132v134.824h241.722V59.567 C270.861,53.7,267.198,49.435,262.162,49.435z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ABEDE6",
    d: "M44.641,207.663v-13.272H29.139v13.272c0,5.725,3.01,10.132,8.699,10.132H53.34 C47.651,217.795,44.641,213.387,44.641,207.663z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M53.34,49.435H37.838c-5.438,0-8.699,3.639-8.699,10.132v134.824h15.502V59.567 C44.641,53.074,47.902,49.435,53.34,49.435z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E4",
    d: "M154.31,206.452c0,1.808-1.468,3.276-3.279,3.276c-1.808,0-3.276-1.468-3.276-3.276 c0-1.811,1.468-3.279,3.276-3.279C152.842,203.173,154.31,204.641,154.31,206.452z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FE6F80",
    d: "M199.903,96.276l-19.268-19.268h-29.474h-0.257H121.43l-19.268,19.268c0,0,10.965,71.636,48.742,77.948 v0.053c0.045-0.008,0.084-0.021,0.129-0.027c0.044,0.006,0.084,0.019,0.129,0.027v-0.053 C188.938,167.912,199.903,96.276,199.903,96.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA1AA",
    d: "M112.487,96.276l19.268-19.268h-10.587L101.9,96.276c0,0,10.965,71.636,48.742,77.948v0.053 c0.044-0.008,0.084-0.021,0.128-0.027c0.044,0.006,0.084,0.019,0.129,0.027v-0.053c1.787-0.298,3.496-0.787,5.165-1.363 C122.458,161.251,112.487,96.276,112.487,96.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E4",
    d: "M146.777,139.449c-1.204,0-2.357-0.479-3.208-1.329l-13.258-13.26c-1.772-1.772-1.772-4.645,0-6.416 c1.772-1.772,4.644-1.772,6.416,0l10.051,10.051l23.881-23.881c1.772-1.772,4.643-1.772,6.416,0 c1.772,1.771,1.772,4.644,0,6.416l-27.089,27.09C149.135,138.97,147.981,139.449,146.777,139.449z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.129,
    y: 236.321,
    fill: "#ABEDE6",
    width: 11.485,
    height: 14.244
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.527,
    y: 217.795,
    fill: "#EFEFEF",
    width: 10.505,
    height: 18.527
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M198.922,255.102h-10.61c-2.506,0-4.537-2.031-4.537-4.537s2.031-4.537,4.537-4.537h6.073v-5.169h-87.719 v5.169h60.094c2.506,0,4.537,2.031,4.537,4.537s-2.031,4.537-4.537,4.537h-64.631c-2.506,0-4.537-2.031-4.537-4.537v-14.244 c0-2.506,2.031-4.537,4.537-4.537h96.793c2.506,0,4.537,2.031,4.537,4.537v14.244 C203.459,253.071,201.429,255.102,198.922,255.102z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M160.528,240.859h-20.001c-2.506,0-4.537-2.031-4.537-4.537v-18.527c0-2.506,2.031-4.537,4.537-4.537 h20.001c2.506,0,4.537,2.031,4.537,4.537v18.527C165.065,238.828,163.034,240.859,160.528,240.859z M145.064,231.784h10.926 v-9.452h-10.926V231.784z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M262.162,222.332H37.838c-7.794,0-13.236-6.032-13.236-14.669v-13.272c0-2.506,2.031-4.537,4.537-4.537 h241.722c2.506,0,4.537,2.031,4.537,4.537v13.272C275.398,216.3,269.956,222.332,262.162,222.332z M33.676,198.928v8.735 c0,2.552,0.722,5.595,4.162,5.595h224.324c3.756,0,4.162-3.912,4.162-5.595v-8.735H33.676z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M270.861,198.928H29.139c-2.506,0-4.537-2.031-4.537-4.537v-91.107c0-2.506,2.031-4.537,4.537-4.537 s4.537,2.031,4.537,4.537v86.57h232.648V59.567c0-2.784-1.286-5.595-4.162-5.595H37.838c-1.351,0-4.162,0-4.162,5.595v22.166 c0,2.506-2.031,4.537-4.537,4.537s-4.537-2.031-4.537-4.537V59.567c0-8.91,5.196-14.669,13.236-14.669h224.324 c7.546,0,13.236,6.307,13.236,14.669v134.824C275.398,196.897,273.368,198.928,270.861,198.928z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M154.31,206.452c0,1.808-1.468,3.276-3.279,3.276c-1.808,0-3.276-1.468-3.276-3.276 c0-1.811,1.468-3.279,3.276-3.279C152.842,203.173,154.31,204.641,154.31,206.452z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M150.904,178.815c-0.499,0-0.992-0.083-1.461-0.242c-39.975-7.49-51.302-78.57-51.767-81.61 c-0.218-1.428,0.256-2.874,1.278-3.895L118.222,73.8c0.851-0.851,2.004-1.329,3.208-1.329h59.205 c1.204,0,2.357,0.478,3.208,1.329l19.268,19.268c1.022,1.021,1.496,2.466,1.277,3.895c-0.467,3.043-11.814,74.243-51.873,81.631 c-0.467,0.151-0.966,0.227-1.449,0.219C151.012,178.814,150.958,178.815,150.904,178.815z M107.037,97.817 c2.187,11.751,13.892,66.08,43.995,71.822c30.103-5.742,41.808-60.072,43.995-71.822l-16.271-16.271h-55.447L107.037,97.817z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M146.777,139.449c-1.204,0-2.357-0.479-3.208-1.329l-13.258-13.26c-1.772-1.772-1.772-4.645,0-6.416 c1.772-1.772,4.644-1.772,6.416,0l10.051,10.051l23.881-23.881c1.772-1.772,4.643-1.772,6.416,0 c1.772,1.771,1.772,4.644,0,6.416l-27.089,27.09C149.135,138.97,147.981,139.449,146.777,139.449z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconComputerShield927Dg34E8C);
export default __webpack_public_path__ + "static/media/reshot-icon-computer-shield-927DG34E8C.60bb69dcc8f574ca4255c8a9bc8b5dcc.svg";
export { ForwardRef as ReactComponent };